
function getParcelaCislo(parcela) {
    let cislo = `${parcela.kmenove_cislo_par}`;
    if (parcela.poddeleni_cisla_par) {
        cislo = `${cislo}/${parcela.poddeleni_cisla_par}`;
    }
    if (parcela.druh_cislovani_par === 1) {
        cislo = `st.${cislo}`;
    }
    return cislo;
}

function getParcelaTypText(parcela) {
    return parcela.par_type;
}

function matchParcelaCislo(parcela, cislo) {
    let match = false;
    let arr = cislo.split('/');
    if (arr.length === 1) {
        match = (parcela.kmenove_cislo_par === parseInt(arr[0]));
    } else {
        match = (parcela.kmenove_cislo_par === parseInt(arr[0]));
        let cisloPod = parseInt(arr[1]);
        if (!isNaN(cisloPod)) {
            match = match && (parcela.poddeleni_cisla_par === cisloPod);
        }
    }
    return match;
}

module.exports = {
    getParcelaCislo,
    getParcelaTypText,
    matchParcelaCislo
};
